import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Shift, ShiftCreate, ShiftFilter } from '../data/shift';

export function createShiftService(client: AxiosInstance) {
  return createCrudService<Shift, ShiftCreate, ShiftFilter>(
    client,
    '/hrm/Shift',
    'id',
  );
}

export type ShiftService = CrudService<Shift, ShiftCreate, ShiftFilter>;
